<script>
import { Doughnut, mixins } from "vue-chartjs";
import { getRandomColor, fetchMusicFilter } from "../base";

export default {
  extends: Doughnut,
  mixins: [mixins.reactiveData],
  data() {
    return {
      chartData: "",
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false
      }
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  async created() {
    await fetchMusicFilter()
      .then((response) => {
        
        this.chartData = response;
      })
      .catch((error) => {
        console.log(error);
        alert("Error: " + error);
      });

    const res = this.chartData;
    
    //get all keys only to array
    const getAllkeys = Object.keys(res).filter((item) => item !== "datasets" && item !== "labels");

    //get all values only to array
    const getAllValues = Object.values(res);

    //map backgroundColor according length of data
    const backgroundColor = getAllValues.map(() => getRandomColor());

    this.chartData = {
      //get all keys from user object
      //labels: Object.keys(user),
      labels: getAllkeys,
      datasets: [
        {
          backgroundColor: backgroundColor,
          data: getAllValues
        }
      ]
    };
  }
};
</script>